import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function TermsOfService() {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (index) => {
    if (expandedSection === index) {
      setExpandedSection(null);
    } else {
      setExpandedSection(index);
    }
  };

  const sections = [
    {
      title: "1. Eligibility",
      content:
        "You must be at least 16 years old to use the Platform. By creating an account or using our services, you represent and warrant that you meet this eligibility requirement.",
    },
    {
      title: "2. Account Registration and Security",
      content:
        "You agree to provide accurate information, maintain the security of your password, and accept responsibility for all activity under your account.",
    },
    {
      title: "3. Services Provided",
      content:
        "Ontrack Careers provides AI-powered assessments, career recommendations, mentorship, and community features. Results are for informational purposes only.",
    },
    {
      title: "4. User Conduct",
      content:
        "You agree not to misuse the Platform, including posting harmful content or violating laws. We may suspend accounts for violations.",
    },
    {
      title: "5. Fees and Payments",
      content:
        "Some services require payment. Payments are processed securely through third-party providers. All sales are final unless otherwise stated.",
    },
    {
      title: "6. Intellectual Property",
      content:
        "All content is owned by or licensed to Ontrack Careers. You may not copy, modify, or distribute any materials without permission.",
    },
    {
      title: "7. Privacy and Data Use",
      content:
        "Your use of the Platform is also governed by our Privacy Policy. By using the Platform, you consent to our data practices.",
    },
    {
      title: "8. Third-Party Links and Tools",
      content:
        "We are not responsible for the content or practices of third-party websites or services linked to our Platform.",
    },
    {
      title: "9. Disclaimer of Warranties",
      content:
        "The platform is provided 'as is'. We do not guarantee uninterrupted service or complete accuracy of information.",
    },
    {
      title: "10. Limitation of Liability",
      content:
        "To the fullest extent allowed by law, we are not liable for indirect or consequential damages resulting from use of the Platform.",
    },
    {
      title: "11. Termination",
      content:
        "We may suspend or terminate your access to the Platform at our discretion for violations of these Terms.",
    },
    {
      title: "12. Governing Law",
      content:
        "These Terms are governed by the laws of the Province of British Columbia, Canada.",
    },
    {
      title: "13. Changes to the Terms",
      content:
        "We may update these Terms periodically. Continued use of the Platform indicates your acceptance of any changes.",
    },
    {
      title: "14. Contact Us",
      content:
        "Email: support@ontrackcareers.com\nLocation: Vancouver, BC, Canada",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden my-20">
      <div className="bg-indigo-600 text-white px-6 py-4">
        <h1 className="text-2xl font-bold">
          Terms of Service for Ontrack Careers
        </h1>
        <div className="flex justify-between text-sm mt-2">
          <div>
            <span className="font-semibold">Effective Date:</span> May 1, 2025
          </div>
          <div>
            <span className="font-semibold">Last Updated:</span> April 24, 2025
          </div>
        </div>
      </div>

      <div className="divide-y divide-gray-200">
        {sections.map((section, index) => (
          <div key={index} className="border-b border-gray-200 last:border-b-0">
            <button
              onClick={() => toggleSection(index)}
              className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none hover:bg-gray-50 transition-colors"
            >
              <h2 className="text-lg font-medium text-gray-900">
                {section.title}
              </h2>
              {expandedSection === index ? (
                <ChevronUp className="h-5 w-5 text-indigo-500" />
              ) : (
                <ChevronDown className="h-5 w-5 text-indigo-500" />
              )}
            </button>

            {expandedSection === index && (
              <div className="px-6 py-4 bg-gray-50">
                <p className="text-gray-700 whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="bg-gray-100 px-6 py-4 text-center">
        <p className="text-sm text-gray-600">
          By using Ontrack Careers, you agree to these Terms of Service.
        </p>
      </div>
    </div>
  );
}
